/* eslint-disable react/require-default-props */
import React from 'react';
import {Platform} from 'react-native';
import {get, has, noop} from 'lodash';

import Icon from '/component/base/Icon';
import SortButtonTeamOrg from '/component/base/SortButton/SortButtonTeamOrg.connect';
import SortButtonWithArrow from '/component/base/SortButton/SortButtonWithArrow';
import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import {Reports} from '/constant/TestIDs';
import {RECORDS_SORTS} from '/enum/sort.enum';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {Loading} from './Loading';
import {styles} from './SortButton.style';
import {
  reportsWithArrowSortButton,
  reportsWithArrowSortButtonTeamOrg,
} from './SortButton.util';
import {generateOnPress} from './SortButton.util';
interface SortButtonProps {
  navigate: () => void;
  recordsName: string;
  sortParams: Record<string, any>;
  setSelectedSortParam: (param: any) => void;
  setSelectedViewTeam?: (param: any) => void;
  reportIsLoading: boolean;
  reportMeta: Record<string, any>;
  loadingData: Record<string, any>;
  tierName: string;
  isViewTeam: string;
}

export const SortButton: React.FC<SortButtonProps> = ({
  navigate = noop,
  recordsName = '',
  sortParams = {},
  setSelectedSortParam = noop,
  setSelectedViewTeam = noop,
  reportIsLoading = true,
  reportMeta = {},
  loadingData = {},
  tierName,
  isViewTeam,
}) => {
  const {tt} = useTranslation('sortButton');
  const hasSortSettings = has(RECORDS_SORTS, recordsName, false);

  const sortLabel = get(sortParams, [recordsName, 'label'], '');
  const sortKey = get(sortParams, [recordsName, 'key'], '');

  const showSortButtonWithArrow =
    reportsWithArrowSortButton.includes(recordsName);
  const showTeamOrgSort =
    reportsWithArrowSortButtonTeamOrg.includes(recordsName);

  let buttonStyles = [styles.container];

  if (hasSortSettings) {
    const recordCount = get(
      reportMeta,
      'page.total',
      get(loadingData, 'total', '0'),
    );

    const isDisabled = reportIsLoading || parseInt(recordCount, 10) === 0;
    if (isDisabled) {
      // @ts-expect-error TS(2345): Argument of type '{ opacity: number; }' is not ass... Remove this comment to see the full error message
      buttonStyles.push(styles.loading);
    }
    const buttonStyle =
      Platform.OS === 'android'
        ? tierName
          ? [styles.buttonSort, isDisabled && styles.loading]
          : buttonStyles
        : tierName
        ? [styles.buttonSortIOS, isDisabled && styles.loading]
        : buttonStyles;
    return showSortButtonWithArrow ? (
      <SortButtonWithArrow
        disabled={reportIsLoading || recordCount === '0'}
        setSelectedSortParam={setSelectedSortParam}
        sortParams={sortParams}
        recordsName={recordsName}
      />
    ) : showTeamOrgSort ? (
      <SortButtonTeamOrg
        disabled={isViewTeam ? false : reportIsLoading}
        loadingData={loadingData}
        reportMeta={reportMeta}
        setSelectedSortParam={setSelectedSortParam}
        setSelectedViewTeam={setSelectedViewTeam}
        sortParams={sortParams}
        recordsName={recordsName}
        isViewTeam={isViewTeam}
      />
    ) : (
      <TouchableOpacity
        {...testProperties(Reports.reportSortButton, true)}
        accessible={true}
        accessibilityLabel={`Sort by: ${sortLabel}`}
        accessibilityRole="button"
        disabled={isDisabled}
        style={buttonStyle}
        onPress={generateOnPress({
          navigate,
          recordsName,
          setSelectedSortParam,
          sortParams,
        })}>
        <Icon name={tierName ? 'sort' : 'filter'} style={styles.iconReport} />

        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          accessible={true}
          accessibilityRole="button"
          style={tierName ? styles.textReport : styles.text}
          testID={Reports.reportSortButtonLabel}>
          {tt(`sortBy-${sortKey}`, `Sort By: ${sortLabel}`)}
        </Text>
        {tierName && <Icon name="chevron-down" style={styles.dropdownIcon} />}
      </TouchableOpacity>
    );
  }

  return <Loading />;
};
